export default __webpack_public_path__ + "static/media/unauthorized.890c413d.svg";